import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { cardSteps, finalVolume, practicePaths, volumes } from '../data/content';
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-339" data-mp="1c5grls4bwfws">
      <div className="mx-auto max-w-4xl" data-id="element-340" data-mp="1c349neykm5jq">
        <div id="volumes-title" data-id="element-341" data-mp="1zut697ifdg6h">
          <SectionHeading eyebrow="What’s inside" title={<>
                What will you find inside the <em className="text-brand-700" data-id="element-343" data-mp="1qud544p5ml4s">Apometry Practice Deck™?</em>
              </>} data-id="element-342" data-mp="1zvuk1jqtsgrw" />
        </div>

        <div className="mt-10 space-y-5" data-id="element-344" data-mp="1vsoeyffg8vn0">
          {volumes.map(v => <article key={v.numeral} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-brand-100 sm:p-8" data-id="element-345" data-mp="ffhi9vgctdd5">
              <div className="flex items-start gap-4" data-id="element-346" data-mp="kekovkbzfrn8">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand-800 font-serif text-xl font-bold text-gold-light" data-id="element-347" data-mp="kc80opfmsl1q">
                  {v.numeral}
                </span>
                <div data-id="element-348" data-mp="20ymvqg6sfkh">
                  <p className="text-xs font-bold uppercase tracking-wider text-brand-600" data-id="element-349" data-mp="21hv2fg1bplb">Volume {v.numeral}</p>
                  <h3 className="mt-1 font-serif text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-350" data-mp="3t6zz42bw1f7p">{v.title}</h3>
                  <p className="mt-1 font-semibold text-brand-700" data-id="element-351" data-mp="b0bwcj4b9457">{v.subtitle}</p>
                </div>
              </div>
              <div className="mt-4 space-y-3 text-[16px] leading-relaxed text-muted" data-id="element-352" data-mp="60h7sm80cqnb">
                {v.intro.map(p => <p key={p} data-id="element-353" data-mp="fsd9s8d7t0wt">{p}</p>)}
              </div>
              <p className="mt-5 text-xs font-bold uppercase tracking-wider text-ink" data-id="element-354" data-mp="fug61a4ynq9z">Includes</p>
              <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-355" data-mp="tq1sb9jt7vyp">
                {v.includes.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-ink/85" data-id="element-356" data-mp="wtr4h2npxb0u">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-357" data-mp="wrwhlisvz8u4" />
                    {item}
                  </li>)}
              </ul>
            </article>)}

          <article className="rounded-3xl bg-brand-900 p-6 text-white sm:p-10" data-id="element-358" data-mp="1bidj125ityr0">
            <div className="flex items-start gap-4" data-id="element-359" data-mp="1bkgjyh87pcai">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gold font-serif text-xl font-bold text-brand-950" data-id="element-360" data-mp="1fjfink3cocti">
                {finalVolume.numeral}
              </span>
              <div data-id="element-361" data-mp="1piy11w3m3qjg">
                <p className="text-xs font-bold uppercase tracking-wider text-gold-light" data-id="element-362" data-mp="1pgbthwgq1b18">Volume {finalVolume.numeral}</p>
                <h3 className="mt-1 font-serif text-2xl font-bold leading-tight sm:text-3xl" data-id="element-363" data-mp="3r9rn9283v60f">{finalVolume.title}</h3>
                <p className="mt-1 font-semibold text-brand-200" data-id="element-364" data-mp="2ykhtxnyyts">{finalVolume.subtitle}</p>
              </div>
            </div>
            <p className="mt-4 text-[16px] leading-relaxed text-brand-100" data-id="element-365" data-mp="2dejkg2nkyk2v">{finalVolume.intro}</p>

            <ul className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-5" data-id="element-366" data-mp="28m87nz7qr3sw">
              {practicePaths.map((p, i) => <li key={p.name} className={`rounded-2xl ${p.color} px-3 py-4 text-center ${i === practicePaths.length - 1 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-367" data-mp="24loch16qaa9e" data-mpi={i}>
                  <p className="font-serif text-lg font-bold uppercase tracking-wide text-white" data-id="element-368" data-mp="2sah8exncoi40">{p.name}</p>
                  <p className="mt-1 text-xs font-semibold text-white/90" data-id="element-369" data-mp="2nb4mqg87th30">{p.count}</p>
                </li>)}
            </ul>

            <p className="mt-8 text-center text-sm font-semibold text-brand-100" data-id="element-370" data-mp="2ickyuaa29v80">
              Every card follows the same simple structure:
            </p>
            <ol className="mt-3 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-2" data-id="element-371" data-mp="16xeh351g6kr9">
              {cardSteps.map((s, i) => <li key={s} className="flex items-center gap-1.5" data-id="element-372" data-mp="2ut2jgc8l3hih" data-mpi={i}>
                  <span className="rounded-full bg-white px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-brand-900 sm:text-sm" data-id="element-373" data-mp="2zm428vbww17c">
                    {s}
                  </span>
                  {i < cardSteps.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-374" data-mp="2qta8jsvpwz9y" />}
                </li>)}
            </ol>

            <div className="mt-8 grid grid-cols-3 gap-2 text-center text-sm font-semibold text-brand-100" data-id="element-375" data-mp="3ijoixf4ivtgv">
              <p data-id="element-376" data-mp="34kotw6d3lck6">No guessing.</p>
              <p data-id="element-377" data-mp="34jds2c37qevp">No searching.</p>
              <p data-id="element-378" data-mp="34m9sc72j9fnb">Nothing to memorize.</p>
            </div>
            <p className="mt-6 text-center font-serif text-2xl font-bold italic text-gold-light" data-id="element-379" data-mp="39i72fvn7dprn">
              Just choose a card and begin.
            </p>
          </article>
        </div>

        <SectionCta label="I want all 6 volumes" data-id="element-380" data-mp="1y54oz9gehgbp" />
      </div>
    </section>;
}